import React from 'react';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: 'Before Psychologist Pro, I spent every Sunday building intake forms and treatment plans from scratch. The Clinical Assessment Toolkit alone gave me back my weekends. My intakes are now faster, more thorough, and far more professional—my clients notice the difference immediately.',
  author: 'Dr. Sarah Mitchell',
  role: 'Licensed Clinical Psychologist',
  location: 'Austin, TX'
}, {
  text: "The Clinical Worksheets Library is the resource I wish I'd had in grad school. I used to hunt through old folders for the right anxiety or cognitive restructuring sheet. Now everything is organized and ready, so I can stay fully present with my clients instead of scrambling between sessions.",
  author: 'James Lawson, LMFT',
  role: 'Marriage & Family Therapist',
  location: 'Denver, CO'
}, {
  text: 'As a newly licensed therapist, the Treatment Planning System gave me the structure I was missing. The SMART goal frameworks and session sequencing guides help me walk into every session knowing exactly where the process is headed. My confidence has completely transformed.',
  author: 'Emily Rodriguez, LCSW',
  role: 'Clinical Social Worker',
  location: 'Chicago, IL'
}, {
  text: 'I introduced this system across my entire group practice. Standardizing our session notes, consent forms, and progress logs cut our documentation time dramatically and kept us fully compliant. The Professional Practice Toolkit paid for itself in the first week.',
  author: 'Dr. Michael Thompson',
  role: 'Group Practice Director',
  location: 'Boston, MA'
}, {
  text: "The bonuses are worth the price on their own. The Therapist's Clinical Phrasebook helped me contain and deepen difficult sessions with so much more fluency, and the 5-Minute Session Prep Vault ended my pre-session paralysis for good. If you run a private practice, you need this.",
  author: 'Jessica Klein, LPC',
  role: 'Private Practice Counselor',
  location: 'Seattle, WA'
}];
export function Testimonials() {
  return <section className="py-14 px-4 sm:px-6 bg-brand-paper border-y border-gray-200" data-id="element-170">
      <div className="text-center mb-12" data-id="element-171">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-172">
          ⭐ 4.9/5 — VERIFIED PROFESSIONAL REVIEWS
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-173">
        {testimonials.map((t, i) => <div key={i} className={`bg-white border border-gray-100 p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow relative ${i === testimonials.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-174">
            <Quote className="absolute top-6 right-6 w-12 h-12 text-brand-paper" data-id="element-175" />
            <div className="flex gap-1 mb-5" data-id="element-176">
              {[...Array(5)].map((_, s) => <Star key={s} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-177" />)}
            </div>
            <p className="text-brand-ink/90 font-medium mb-8 leading-relaxed text-sm italic relative z-10" data-id="element-178">
              "{t.text}"
            </p>
            <div className="border-t border-gray-100 pt-5 flex items-center gap-4" data-id="element-179">
              <div className="w-12 h-12 rounded-full bg-brand-navy text-white flex items-center justify-center font-bold text-lg shadow-inner" data-id="element-180">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-181">
                <p className="font-bold text-brand-navy text-sm mb-1" data-id="element-182">
                  {t.author}
                </p>
                <p className="text-[11px] text-brand-ink/60 font-bold uppercase tracking-wide" data-id="element-183">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}